import React from "react";
import { Instruction, Instructions } from "../shared_ui.jsx";

export const WebAppInstructions = () => (
  <Instructions>
    <Instruction
      number={"1"}
      instruction={
        "Upload your documents on app.printwithme.com/print or click the button above."
      }
    />
    <Instruction
      number={"2"}
      instruction={
        "Follow the instructions to complete your payment. Once you are done you will receive a unique secure release code."
      }
    />
    <Instruction
      number={"3"}
      instruction={
        "Enter your secure release code on the printer’s touchscreen to print your documents."
      }
    />
  </Instructions>
);
